<template>
  <div style="font-size: 14px">
    <div class="d-flex justify-content-between align-items-center">
      <span> <b>Conditional fees and codes</b> </span>
      <div class="d-flex ">
        <b-button variant="primary" @click="newConditionModal = true"
          >Add Rule</b-button
        >
      </div>
    </div>
    <div class="mt-2">
      <draggable v-model="conditions">
        <div
          class="variation-container px-2 py-2 mt-2 position-relative shadow-sm"
          v-for="(condition, index) in conditions"
          :key="index"
          :data-id="condition.id"
        >
          <service-cost-variation-rule-item
            :condition="condition"
            :billingCode="condition.billingCode"
            :mod1="condition.mod1"
            :mod2="condition.mod2"
            :mod3="condition.mod3"
            :mod4="condition.mod4"
            :order="index"
            @delete="removeCondition"
            @edit="editCondition"
            :payors="payors"
            :credentials="credentials"
            :scheduleEventStatuses="scheduleEventStatuses"
          />
        </div>
      </draggable>
    </div>

    <service-billing-cost-variation-add-edit-modal
      :formTitle="
        currentCondition ? `Edit conditional rule` : `Add conditional rule`
      "
      :show="newConditionModal"
      @onHiddenEdit="setCondition"
      @onHiddenAdd="() => resetNewConditionModalDefaultsData()"
      :service="service"
      :payors="payors"
      :credentials="credentials"
      :scheduleEventStatuses="scheduleEventStatuses"
      @onEditCondition="setCondition"
      @onAddCondition="addCondition"
      :currentCondition="currentCondition"
    />
  </div>
</template>

<script>
import catalogServer from "../../server/catalog";
import insuranceCompaniesServer from "../../server/insuranceCompany";
import userServer from "../../server/user";
import ServiceCostVariationRuleItem from "./ServiceCostVariationRuleItem.vue";
import ServiceBillingCostVariationAddEditModal from "./ServiceBillingCostVariationAddEditModal.vue";
import Draggable from "vuedraggable";
export default {
  name: "ServiceBillingCodeCostVariationConditionEditor",
  props: ["defaultCost", "service"],
  components: {
    ServiceCostVariationRuleItem,
    ServiceBillingCostVariationAddEditModal,
    Draggable
  },
  data() {
    return {
      conditions: [],
      scheduleEventStatuses: [],
      payors: [],
      credentials: [],
      newConditionModal: false,
      currentCondition: null
    };
  },
  async mounted() {
    this.scheduleEventStatuses = await catalogServer.getScheduleEventStatuses();
    this.payors = await insuranceCompaniesServer.query({
      page: 0,
      pageSize: 1000000
    });
    this.credentials = await userServer.getCredentials();
    if (this.$attrs.value && this.$attrs.value.length > 0) {
      let conditions = this.$attrs.value.map(condition => ({
        costVariation: `${condition.costPerUnit}`,
        statements: condition.costVariationRules
          ? JSON.parse(condition.costVariationRules).map(statement => ({
              field: statement.source,
              logicalOperator: statement.compareOperator,
              value: this.findStatementsValues(
                statement.source,
                statement.value
              )
            }))
          : "",
        id: condition.id,
        error: [],
        billingCode: condition.billingCode,
        mod1: condition.mod1,
        mod2: condition.mod2,
        mod3: condition.mod3,
        mod4: condition.mod4
      }));
      conditions = conditions.filter(condition => {
        for (let index = 0; index < condition.statements.length; index++) {
          const statement = condition.statements[index];
          if (!statement.value) {
            return false;
          }
        }
        return true;
      });
      this.conditions = conditions;
    }
  },
  methods: {
    addCondition(condition) {
      this.conditions.push(condition);
      this.resetNewConditionModalDefaultsData();
    },
    setCondition({ condition, index }) {
      this.conditions = [
        ...this.conditions.slice(0, index),
        condition,
        ...this.conditions.slice(index + 1)
      ];
      this.resetNewConditionModalDefaultsData();
    },
    removeCondition(index) {
      this.$dialog
        .alert(
          {
            title: "Are you sure you want to delete this condition?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          this.conditions.splice(index, 1);
        });
    },
    editCondition(index) {
      this.currentCondition = {
        index: index,
        condition: this.conditions[index]
      };
      this.newConditionModal = true;
    },
    findStatementsValues(source, id) {
      if (id) {
        switch (source) {
          case "payor":
            return this.payors.records.find(item => item.id === id)?.id;
          case "credentials":
            return this.credentials.find(item => item.id === id)?.id;
          case "supervisorCredentials":
            return this.credentials.find(item => item.id === id)?.id;
          default:
            return this.scheduleEventStatuses.find(status => status.id === id)
              ?.id;
        }
      }
    },
    resetNewConditionModalDefaultsData() {
      this.newConditionModal = false;
      this.currentCondition = null;
    }
  },
  watch: {
    "$attrs.value": {
      handler: function(newVal, oldVal) {
        if (
          newVal !== undefined &&
          newVal.length > 0 &&
          !oldVal.some(condition => condition.id) &&
          newVal.length === oldVal.length
        ) {
          newVal.forEach((condition, index) => {
            if (condition.statements.length > 0) {
              condition.statements.forEach((statement, statementIndex) => {
                if (
                  oldVal[index].statements.length > 0 &&
                  statement.source !== "" &&
                  statement.source !==
                    oldVal[index].statements[statementIndex].source
                ) {
                  if (this.conditions.length > 0) {
                    this.conditions[index].statements[statementIndex].value =
                      "";
                  }
                }
              });
            }
          });
        }
      },
      deep: true,
      immediate: false
    }
  }
};
</script>

<style>
.variation-container {
  border: 2px solid #f3f5f6;
  width: 100%;
  /* box-shadow: 0 3px 5px rgba(0, 0, 0, 0.5), 0 0 0 3px rgba(0, 0, 0, 0.5) inset; */
}
.error {
  border: 3px solid #ff6161;
}
</style>
